import { Link } from "react-router-dom";
import PageBanner from "../../PageBanner";
import SocialMediaSidebar from "../../SocialMediaSidebar";
import SectionHeader from "../../SectionHeader";
import surveillanceImage from "../../../assets/images/vblog5.png"; // Replace with correct surveillance image
import ScrollToTopButton from "../../ScrollToTopButton";

const Surveillance = () => {
  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <PageBanner
        title="Real-Time Monitoring with Integrated Cameras"
        breadcrumb={[
          { label: "Home", href: "/" },
          // { label: "Resources" },
          { label: "Blogs" },
        ]}
      />
      <div className="max-w-6xl mx-auto p-4">
        <SectionHeader
          title="Real-Time Monitoring with Integrated Cameras @ GyanYantram"
          shareUrl="https://yourdomain.com/blog/surveillance-integration"
        />
      </div>
      <div>
        <ScrollToTopButton />
      </div>

      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row gap-8 mb-10">
            <div className="lg:w-2/3">
              <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
                Summary
              </h4>
              <p className="text-black mb-4 text-lg">
                Cameras embedded in smart poles offer 24/7 surveillance for public areas.
                GyanYantram enables high-resolution monitoring, motion detection,
                and remote access, making urban environments safer and more secure.
              </p>
              <p className="text-black text-lg">
                These solutions allow authorities to act proactively, deterring crime
                and enhancing emergency response through live feeds and data analytics.
              </p>
            </div>
            <div className="lg:w-1/3">
              <img src={surveillanceImage} alt="Surveillance Camera System" className="rounded-lg" />
              <p className="text-sm text-gray-500 mt-2 italic">
                24/7 surveillance through smart camera technology
              </p>
            </div>
          </div>

          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              Introduction
            </h4>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="md:col-span-2">
                <p className="text-black mb-4 text-lg">
                  Urban safety demands constant vigilance. Traditional patrol methods
                  fall short in real-time coverage and timely alerts.
                </p>
                <p className="text-black text-lg">
                  GyanYantram's integrated surveillance system enables remote monitoring
                  with high-definition visuals and smart alerts, empowering cities to detect
                  and respond before incidents escalate.
                </p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-[#00D084]">
                <h5 className="font-bold text-lg mb-2">Did You Know?</h5>
                <p className="text-gray-700">
                  Cities with smart surveillance systems report up to 40% reduction
                  in street crime and faster police response times.
                </p>
              </div>
            </div>
          </div>

          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-4 text-black">
              Key Features of Smart Surveillance Integration:
            </h5>
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-blue-500">
                  <h6 className="font-semibold text-lg mb-2">High-Resolution Imaging</h6>
                  <p className="text-gray-700">
                    Crystal-clear footage, even in low-light environments, helps in accurate monitoring.
                  </p>
                </div>
                <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-green-500">
                  <h6 className="font-semibold text-lg mb-2">Real-Time Streaming</h6>
                  <p className="text-gray-700">
                    Live feed access from anywhere enhances decision-making during emergencies.
                  </p>
                </div>
                <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-purple-500">
                  <h6 className="font-semibold text-lg mb-2">Motion Detection</h6>
                  <p className="text-gray-700">
                    Smart motion sensors trigger alerts for unauthorized or suspicious activities.
                  </p>
                </div>
              </div>
              <div>
                <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-red-500">
                  <h6 className="font-semibold text-lg mb-2">Remote Access</h6>
                  <p className="text-gray-700">
                    View and control cameras remotely via secure dashboards or mobile apps.
                  </p>
                </div>
                <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-yellow-500">
                  <h6 className="font-semibold text-lg mb-2">Cloud Storage</h6>
                  <p className="text-gray-700">
                    Secure footage archiving for audits, investigations, and historical review.
                  </p>
                </div>
                <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-indigo-500">
                  <h6 className="font-semibold text-lg mb-2">AI-Powered Analytics</h6>
                  <p className="text-gray-700">
                    Use facial recognition and behavior analysis for advanced situational awareness.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="mb-10 bg-gray-50 p-6 rounded-lg">
            <h5 className="text-xl font-semibold mb-4 text-black text-center">
              Impact of Surveillance on Urban Safety
            </h5>
            <div className="grid md:grid-cols-3 gap-4">
              <div className="bg-white p-4 rounded-lg shadow text-center">
                <div className="text-3xl font-bold text-[#00D084] mb-2">40%</div>
                <p className="text-gray-700">Drop in petty crime rates</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow text-center">
                <div className="text-3xl font-bold text-[#00D084] mb-2">35%</div>
                <p className="text-gray-700">Improved incident response time</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow text-center">
                <div className="text-3xl font-bold text-[#00D084] mb-2">50%</div>
                <p className="text-gray-700">Increase in law enforcement efficiency</p>
              </div>
            </div>
          </div>

          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-3 text-black">Conclusion</h5>
            <div className="flex flex-col md:flex-row gap-6">
              <div className="md:w-2/3">
                <p className="text-black text-lg">
                  GyanYantram’s integrated surveillance systems redefine urban safety.
                  Through smart cameras, AI, and remote access, cities gain a powerful
                  ally in maintaining order and protecting citizens round the clock.
                </p>
              </div>
              <div className="md:w-1/3 bg-[#00D084] bg-opacity-10 p-4 rounded-lg">
                <h6 className="font-semibold text-lg mb-2">Looking Ahead</h6>
                <p className="text-gray-700">
                  Future features may include drone camera integration, crowd detection,
                  and AI-generated threat-level assessments.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 p-6 rounded-lg">
            <h5 className="text-xl font-semibold mb-3 text-black">
              GyanYantram’s Contribution
            </h5>
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <p className="text-black mb-4 text-lg">
                  GyanYantram delivers advanced surveillance solutions integrated into
                  smart city infrastructure. With seamless monitoring, smart alerts,
                  and AI-ready features, they redefine public security.
                </p>
                <p className="text-black text-lg">
                  Learn more at{" "}
                  <a
                    href="https://gyanyantram.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#00D084] hover:underline"
                  >
                    www.gyanyantram.com
                  </a>
                </p>
              </div>
              <div>
                <ul className="list-disc pl-6 space-y-2 text-lg text-black">
                  <li><strong>24/7 Monitoring:</strong> Constant surveillance across public spaces</li>
                  <li><strong>Smart Detection:</strong> Motion and object-based alerts</li>
                  <li><strong>AI Integration:</strong> Facial recognition and behavior analysis</li>
                  <li><strong>Urban Safety:</strong> Ideal for traffic zones, campuses, and public areas</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Surveillance;
